import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { mapECItemToCardObject } from '../browse/search';
import { settings } from './setup';

/**
 * Gets the ECAPPS for a specific org
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to authorize the request
 * @param {pageSize} params.pageSize - the number of items per page
 * @param {string} params.publisherId - the ID of the publisher
 * @param {number} [params.pageSize] - the number of items per page
 * @param {string} [params.appType] - app type filter
 * @param {string} [params.sort] - sort by
 */
export default async (params = {}, signal = null) => {
  const pageIndex = 0;
  const pageSize = params.pageSize || 12;
  const sortBy = params.sort || 'MOST_RECENT';
  const requiredParams = ['publisherId'];
  const paramsRules = { publisherId: { allowedTypes: ['string'] } };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }

  const headers = new Headers({
    'x-api-key': settings.apiKey,
  });

  if (params.authToken) {
    headers.append('Authorization', params.authToken);
  }

  const search = new URLSearchParams({ pageIndex, pageSize, sortBy });
  if (params.appType) {
    search.append('appType', params.appType);
  }
  const response = await fetch(`${settings.endpoint}/v2/publishers/${params.publisherId}/apps?${search}`, {
    signal,
    headers,
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return {
      ...content,
      cloudApps: content?.cloudApps?.map(mapECItemToCardObject),
    };
  }
};
